import Badge from "@/common/components/Badge";
import { EquipmentModelData } from "../types/equipmentModels";
import { ArrowBigRight, Car, FileBox } from "lucide-react";
import { strategy as kindStrategy } from "../constants/kindOptions.constant";
import { Link } from "react-router-dom";
import Button from "../../../common/components/Button";

export class EquipmentModelsTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (equipmentModels: EquipmentModelData[]) => {
      return equipmentModels.map((equipmentModel) => ({
        ...equipmentModel,
        kind: kindStrategy[equipmentModel.kind as keyof typeof kindStrategy],
        category_display_name: equipmentModel.category.display_name,
        fuel: equipmentModel.applicable_products[0] ? (
          <div data-tooltip-id={equipmentModel.id} className="flex items-center gap-2">
            <Badge Icon={FileBox} text={equipmentModel.applicable_products[0].display_name} />

            {equipmentModel.applicable_products.length - 1 > 0 && (
              <span>+{equipmentModel.applicable_products.length - 1}</span>
            )}
          </div>
        ) : 'Nenhum',
        actions: <Link to={`/equipment-models/${equipmentModel.id}`}>
          <Button name={'access_equipment_models_list'} className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
            <ArrowBigRight />
          </Button>
        </Link>
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (equipmentModels: EquipmentModelData[]) => {
      return equipmentModels.map((equipmentModel) => ({
        route: `/equipment-models/${equipmentModel.id}`,
        items: [
          ['Marca', equipmentModel.brand],
          ['Modelo', equipmentModel.display_name],
          ['Categoria', equipmentModel.category.display_name],
          ['Ano', equipmentModel.year],
        ]
      }));
    };
  }

  static optionsTransformer() {
    return (equipmentModels: EquipmentModelData[]) => {
      return equipmentModels.map((equipmentModel) => {
        return {
          value: equipmentModel.id,
          label: equipmentModel.display_name,
          icon: <Car strokeWidth={1} size={20} />
        };
      });
    };
  }
}
